import PromoEmbed from './PromoEmbed';

export default PromoEmbed;